import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MainFacade } from '../main.facade';

@Component({
  selector: 'app-leaderboard',
  templateUrl: './leaderboard.component.html',
  styleUrls: ['./leaderboard.component.scss']
})
export class LeaderboardComponent implements OnInit, OnDestroy {
  public allSkills$: Observable<any>|undefined;
  public scores$: Observable<any>|undefined;
  public season$: Observable<any>|undefined;
  public pastSeason$: Observable<any>|undefined;
  public user$: Observable<any>|undefined;
  public userScore$: Observable<any>|undefined;
  topThree:any[]=[];
  remainScores:any[]=[]
  private destroy$ = new Subject();
  skillSelect:number=1;
  user:any='';
  constructor(private mainfacade:MainFacade) { }

  ngOnInit(): void {
    this.setObservables();
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }

  setObservables() {
    this.scores$ = this.mainfacade.scores$;
    this.userScore$ = this.mainfacade.userScore$;
    this.user$ = this.mainfacade.user$;
    this.allSkills$ = this.mainfacade.allSkills$;
    this.season$ = this.mainfacade.season$;
    this.pastSeason$ = this.mainfacade.pastSeason$;
    this.scores$
    .pipe(takeUntil(this.destroy$))
    .subscribe((message)=>{ 
      if(message){
        this.topThree=[];
        this.remainScores=[];
        message.forEach((element,idx) => {
          if(idx < 3){
            this.topThree.push(element);
          }
          else{
            this.remainScores.push(element);
          }
        });
        
      }
    });

    this.user$
    .pipe(takeUntil(this.destroy$))
    .subscribe((message)=>{ 
      if(message){
        this.user = message;
        this.mainfacade.getScores(this.skillSelect, this.user?.Id);
      }
    });
  }

  selectSkill(id){
    this.mainfacade.getScores(id, this.user?.Id);
  }

  loadleaders(){
    this.mainfacade.getScores(this.skillSelect, this.user?.Id);
  }

}
